import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* uploadv3(action) {
  var payload = {
    action: "portal/initUpload3",
    assetId: action.assetId,
    estimatedChunks: action.estimatedChunks,
    originalName: action.originalName,
    name: action.name,
    size: action.size,
    mimeType: action.mimeType,
    formDataId: action.formDataId,
  };

  yield put(serverRequest(payload));
}

export default uploadv3;
